import { QClassificationPayload } from "../pages/QClassification/sections/ClassificationForm";
import instance from "../services/axios";

export const submitQClassification = async (
  payload: QClassificationPayload
) => {
  const response = await instance.post(
    "/v1.0/Quality/add-q-classification",
    payload
  );
  return response.data;
};

export const removeClassification = async (payload: string[]) => {
  const response = await instance.delete('/v1.0/Quality/remove-classification', {
    data: {
      serialnumbers: payload,
    },
  });

  return response.data
}
